import { createGetPropGetter } from '@/store/utils';
// eslint-disable-next-line import/no-cycle
import organizations from '@/store/organization';
// eslint-disable-next-line import/no-cycle
import user from '@/store/user';

export default {
  defaultLicense: createGetPropGetter('defaultLicense', []),
  licenses() {
    // Post-migration: derive from licenseData (new license table)
    const ld = user.state.licenseData;
    if (ld && ld.permissions && !ld.permissions.isExpired) {
      // Tenant has active license — all orgs are considered "licensed"
      const result = {};
      organizations.state.organizations.forEach(org => {
        result[org.name] = [{ type: 'sku', license: ld.license }];
      });
      const companyName = user.state.companyData?.name;
      if (companyName && !result[companyName]) {
        result[companyName] = [{ type: 'sku', license: ld.license }];
      }
      return result;
    }

    // Fallback: legacy org.license data (transition period)
    const licensePerOrganization = {};
    organizations.state.organizations.forEach(org => {
      licensePerOrganization[org.name] = org.license;
    });
    if (!Object.keys(licensePerOrganization).includes(user.state.companyData.name)) {
      licensePerOrganization[user.state.companyData.name] = user.state.companyData.license;
    }
    return licensePerOrganization;
  },
};
